<script lang="ts">const { toggleAskSquare } = $props();
</script>

<button onclick={toggleAskSquare} title="Ask Square" aria-label="Open Ask Square">
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 2.5C16.2091 2.5 18 4.29086 18 6.5V8H19C21.2091 8 23 9.79086 23 12V16.5C23 18.7091 21.2091 20.5 19 20.5H17V18.5H19C20.1046 18.5 21 17.6046 21 16.5V12C21 10.8954 20.1046 10 19 10H18V11C18 13.2091 16.2091 15 14 15H8V16.5C8 17.6046 8.89544 18.5 10 18.5H12.5859C13.1163 18.5 13.625 18.7109 14 19.0859L17.207 22.293L15.793 23.707L12.5859 20.5H10C7.79087 20.5 6 18.7091 6 16.5V15H5C2.79086 15 1 13.2091 1 11V6.5C1 4.29086 2.79086 2.5 5 2.5H14ZM5 4.5C3.89543 4.5 3 5.39543 3 6.5V11C3 12.1046 3.89543 13 5 13H6V12C6 9.79086 7.79086 8 10 8H16V6.5C16 5.39543 15.1046 4.5 14 4.5H5ZM10 10C8.89543 10 8 10.8954 8 12V13H14C15.1046 13 16 12.1046 16 11V10H10Z"
      fill="currentColor"
    />
  </svg>
</button>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
button {
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: auto;
  height: auto;
  min-height: 0;
  max-height: none;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding: 10px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text, var(--color-neutral-000, #000000));
  letter-spacing: normal;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  background-color: transparent;
  border: none;
  cursor: pointer;
  line-height: 1;
  padding: 18px 10px;
}
button:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}
button:focus {
  background: transparent;
  outline: none;
}
button:hover {
  background: transparent;
}
button:hover {
  opacity: 0.7;
}</style>
